module.exports = __webpack_public_path__ + "static/media/home-card-04.450ca472.png";